// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveTwoToneSvg from "@ant-design/icons-svg/es/asn/SaveTwoTone";
import AntdIcon from '../components/AntdIcon';

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveTwoToneSvg
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
export default React.forwardRef(SaveTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SaveTwoTone.js
// module id = 1751
// module chunks = 0